import { reducer as notificationReducer } from './notification.slice';

export default notificationReducer;
